import { requestJson } from "@/lib/api";

/** Unidade de compra do próprio cliente (self-service no checkout). */
export interface CustomerDeliveryUnit {
  id: string;
  externalCode: string;
  name: string;
  address?: string | null;
  district?: string | null;
  city?: string | null;
  postalCode?: string | null;
  deliveryWindowText?: string | null;
  email?: string | null;
  active: boolean;
}

/** Lista as unidades de compra ATIVAS da conta autenticada. */
export async function fetchMyDeliveryUnits(): Promise<CustomerDeliveryUnit[]> {
  return requestJson<CustomerDeliveryUnit[]>("/api/v1/delivery-units");
}
